<template>
  <sidebar-row>
    <v-subheader class="text-left font-weight-medium font--text pa-0" style="font-size: 14px">
      {{ $i18n.t('sidebar.categoryVisualization') }}
    </v-subheader>
    <v-row no-gutters v-for="item in items" :key="item.id">
      <v-col>
        <v-checkbox :value="item.name" v-model="computedValue" style="height: 36px" class="mt-1" color="primary">
          <template #label>
            <v-row no-gutters class="justify-space-between" style="align-items: center">
              <v-col cols="auto" class="font--text" style="font-size: 14px"> {{ item.name }}: </v-col>
              <v-col cols="3">
                <v-chip label color="info" text-color="white" class="pa-2 px-3" style="height: 24px">
                  {{ item.investments_count }}
                </v-chip>
              </v-col>
            </v-row>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </sidebar-row>
</template>

<script>
import SidebarRow from '@/components/SidebarRow';
export default {
  name: 'InvestmentCategoryVisualization',
  components: { SidebarRow },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    picked: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.picked;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
  },
};
</script>

<style scoped></style>
